import React, { useState } from 'react'
import useAlphabeticNumericButtonTheme from '../button-themes/useAlphabeticNumericButtonTheme'

const useButtonThemeForKeyboard = () => {
  const { defaultButtonTheme } = useAlphabeticNumericButtonTheme()
  const [buttonTheme, setButtonThemeForKeyboard] = useState(defaultButtonTheme)

  return [buttonTheme, setButtonThemeForKeyboard]
}

export default useButtonThemeForKeyboard
